import { prop } from "./utils";
export var sizeProps = function sizeProps(p) {
  return "\n" + prop("minWidth", function (val) {
    return "min-width:" + val;
  })(p) + ";\n" + prop("width")(p) + ";\n" + prop("maxWidth", function (val) {
    return "max-width:" + val;
  })(p) + ";\n\n" + prop("minHeight", function (val) {
    return "min-height:" + val;
  })(p) + ";\n" + prop("height")(p) + ";\n" + prop("maxHeight", function (val) {
    return "max-height:" + val;
  })(p) + ";\n";
};
export var overflowProps = function overflowProps(p) {
  return "\n" + prop("overflow")(p) + ";\n" + prop("overflowX", function (val) {
    return "overflow-x: " + val;
  })(p) + ";\n" + prop("overflowY", function (val) {
    return "overflow-y: " + val;
  })(p) + ";\n";
};
export var gridContainerProps = function gridContainerProps(p) {
  return "\ndisplay:grid;\n" + prop("inline", "display:inline-grid")(p) + ";\n\n" + prop("templateRows", function (val) {
    return "grid-template-rows:" + val;
  })(p) + ";\n" + prop("templateColumns", function (val) {
    return "grid-template-columns:" + val;
  })(p) + ";\n" + prop("templateAreas", function (val) {
    return "grid-template-areas:" + val;
  })(p) + ";\n\n" + prop("template", function (val) {
    return "grid-template:" + val;
  })(p) + ";\n\n" + prop("autoRows", function (val) {
    return "grid-auto-rows:" + val;
  })(p) + ";\n" + prop("autoColumns", function (val) {
    return "grid-auto-columns:" + val;
  })(p) + ";\n" + prop("autoFlow", function (val) {
    return "grid-auto-flow:" + val;
  })(p) + ";\n\n" + prop("grid", function (val) {
    return "grid:" + val;
  })(p) + ";\n\n" + prop("rowGap", function (val) {
    return "grid-row-gap:" + val;
  })(p) + ";\n" + prop("columnGap", function (val) {
    return "grid-column-gap:" + val;
  })(p) + ";\n" + prop("gap", function (val) {
    return "grid-gap:" + val;
  })(p) + ";\n\n" + prop("justifyContent", function (val) {
    return "justify-content:" + val;
  })(p) + ";\n" + prop("alignContent", function (val) {
    return "align-content:" + val;
  })(p) + ";\n" + prop("justifyItems", function (val) {
    return "justify-items:" + val;
  })(p) + ";\n" + prop("alignItems", function (val) {
    return "align-items:" + val;
  })(p) + ";\n";
};
export var gridItemProps = function gridItemProps(p) {
  return "\n" + prop("rowStart", function (val, rawVal) {
    return "grid-row-start:" + rawVal;
  })(p) + ";\n" + prop("rowEnd", function (val, rawVal) {
    return "grid-row-end:" + rawVal;
  })(p) + ";\n" + prop("columnStart", function (val, rawVal) {
    return "grid-column-start:" + rawVal;
  })(p) + ";\n" + prop("columnEnd", function (val, rawVal) {
    return "grid-column-end:" + rawVal;
  })(p) + ";\n\n" + prop("row", function (val, rawVal) {
    return "grid-row:" + rawVal;
  })(p) + ";\n" + prop("column", function (val, rawVal) {
    return "grid-column:" + rawVal;
  })(p) + ";\n" + prop("area", function (val, rawVal) {
    return "grid-area:" + rawVal;
  })(p) + ";\n\n" + prop("justify", function (val) {
    return "justify-self:" + val;
  })(p) + ";\n" + prop("align", function (val) {
    return "align-self:" + val;
  })(p) + ";\n\n" + prop("zIndex", function (val, rawVal) {
    return "z-index:" + rawVal;
  })(p) + ";\n" + prop("order", function (val, rawVal) {
    return "order:" + rawVal;
  })(p) + ";\n\n" + prop("center", "justify-self:center")(p) + ";\n" + prop("middle", "align-self:center")(p) + ";\n" + prop("top", "align-self:start")(p) + ";\n" + prop("right", "justify-self:end")(p) + ";\n" + prop("bottom", "align-self:end")(p) + ";\n" + prop("left", "justify-self:start")(p) + ";\n";
};
export var flexGap = function flexGap(val, rawVal, p) {
  // Usefull when setting items width
  if (p.gapType === "padding") {
    return "margin-top:-" + val + ";margin-left:-" + val + ";>*{box-sizing:border-box;padding-top:" + val + ";padding-left:" + val + "}";
  }
  return "margin-top:-" + val + ";margin-left:-" + val + ";>*{margin-top:" + val + ";margin-left:" + val + "}";
};
export var flexRowGap = function flexRowGap(val, rawVal, p) {
  // Usefull when setting items width
  if (p.gapType === "padding") {
    return "margin-top:-" + val + ";>*{box-sizing:border-box;padding-top:" + val + "}";
  }
  return "margin-top:-" + val + ";>*{margin-top:" + val + "}";
};
export var flexColumnGap = function flexColumnGap(val, rawVal, p) {
  // Usefull when setting items width
  if (p.gapType === "padding") {
    return "margin-left:-" + val + ";>*{box-sizing:border-box;padding-left:" + val + "}";
  }
  return "margin-left:-" + val + ";>*{margin-left:" + val + "}";
};
export var flexContainerProps = function flexContainerProps(p) {
  return "\ndisplay:flex;\n" + prop("inline", "display:inline-flex")(p) + ";\n" + prop("direction", function (val) {
    return "flex-direction:" + val;
  })(p) + ";\n" + prop("column", "flex-direction:column")(p) + ";\n" + prop("wrap", "flex-wrap:wrap")(p) + ";\n" + prop("flow", function (val) {
    return "flex-flow:" + val;
  })(p) + ";\n\n" + prop("rowGap", flexRowGap)(p) + ";\n" + prop("columnGap", flexColumnGap)(p) + ";\n" + prop("gap", flexGap)(p) + ";\n\n" + prop("justifyContent", function (val) {
    return "justify-content:" + val;
  })(p) + ";\n" + prop("alignContent", function (val) {
    return "align-content:" + val;
  })(p) + ";\n" + prop("alignItems", function (val) {
    return "align-items:" + val;
  })(p) + ";\n\n" + (p.column || p.direction === "column" ? "\n      " + prop("center", "align-items:center")(p) + ";\n      " + prop("middle", "justify-content:center")(p) + ";\n      " + prop("top", "justify-content:flex-start")(p) + ";\n      " + prop("right", "align-items:flex-end")(p) + ";\n      " + prop("bottom", "justify-content:flex-end")(p) + ";\n      " + prop("left", "align-items:flex-start")(p) + ";\n      " : "\n      " + prop("center", "justify-content:center")(p) + ";\n      " + prop("middle", "align-items:center")(p) + ";\n      " + prop("top", "align-items:flex-start")(p) + ";\n      " + prop("right", "justify-content:flex-end")(p) + ";\n      " + prop("bottom", "align-items:flex-end")(p) + ";\n      " + prop("left", "justify-content:flex-start")(p) + ";\n      ") + ";\n";
};
export var flexItemProps = function flexItemProps(p) {
  return "\n" + prop("grow", function (val, rawVal) {
    return "flex-grow:" + rawVal;
  })(p) + ";\n" + prop("shrink", function (val, rawVal) {
    return "flex-shrink:" + rawVal;
  })(p) + ";\n" + prop("basis", function (val) {
    return "flex-basis:" + val;
  })(p) + ";\n" + prop("flex", function (val) {
    return "flex:" + val;
  })(p) + ";\n\n" + prop("zIndex", function (val, rawVal) {
    return "z-index:" + rawVal;
  })(p) + ";\n" + prop("order", function (val, rawVal) {
    return "order:" + rawVal;
  })(p) + ";\n\n" + prop("alignSelf", function (val) {
    return "align-self:" + val;
  })(p) + ";\n" +
  // eslint-disable-next-line
  prop("justifySelf", function (val) {
    if (val === "center") return "margin-left:auto;margin-right:auto";
    if (val === "start") return "margin-right:auto";
    if (val === "end") return "margin-left:auto";
  })(p) + ";\n\n" + prop("center", "margin-left:auto;margin-right:auto")(p) + ";\n" + prop("middle", "margin-top:auto;margin-bottom:auto")(p) + ";\n" + prop("top", "margin-bottom:auto")(p) + ";\n" + prop("right", "margin-left:auto")(p) + ";\n" + prop("bottom", "margin-top:auto")(p) + ";\n" + prop("left", "margin-right:auto")(p) + ";\n";
};